/* ==============================================
   NSD Customer Service Chatbot - Logic
   Handles: FAQ matching, order tracking, escalation
   Zero external dependencies, fully client-side
   ============================================== */

(function () {
  "use strict";

  // ========== FAQ Knowledge Base ==========
  var FAQ_DATA = [
    {
      id: "shipping_time",
      keywords: ["shipping", "ship", "how long", "when will", "delivery", "deliver", "arrive", "get my order", "when does", "time", "days", "long does it take", "production", "made to order", "make to order", "processing"],
      response: 'All No Sad Days items are <strong>made to order</strong>, so production takes <strong>10\u201314 business days</strong>. Once your order ships, you\u2019ll receive an email with tracking info. Most orders arrive within 3\u20135 business days after shipping.<br><br>Want to check on a specific order?',
      followUp: "track_order"
    },
    {
      id: "track_order",
      keywords: ["track", "tracking", "where is my order", "order status", "order number", "where's my", "find my order", "check order", "check my order", "look up", "my order"],
      response: 'To check your order status:<br><br>\u2022 Check your <strong>email inbox</strong> (and spam folder) for your order confirmation from No Sad Days<br>\u2022 That email has a <strong>View your order</strong> link with live status updates<br>\u2022 Once shipped, you\u2019ll get a separate email with your <strong>USPS tracking number</strong><br><br>Can\u2019t find your confirmation email? Try logging into <a href="/account" style="color:#000;font-weight:700">your account</a> to view order history, or email <a href="mailto:info@nosaddays.com" style="color:#000;font-weight:700">info@nosaddays.com</a> with your order number and we\u2019ll look it up for you.'
    },
    {
      id: "returns",
      keywords: ["return", "returns", "exchange", "swap", "size exchange", "wrong size", "doesn't fit", "too big", "too small", "refund"],
      response: 'Here\u2019s our exchange policy:<br><br>\u2022 You have <strong>30 days from delivery</strong> to request an exchange<br>\u2022 Items must be <strong>unworn and unwashed</strong> with tags attached<br>\u2022 We offer <strong>exchanges for different sizes only</strong> \u2014 no refunds<br>\u2022 <strong>Sale and promotional items are final sale</strong><br><br>To start an exchange, email <a href="mailto:info@nosaddays.com" style="color:#000;font-weight:700">info@nosaddays.com</a> with your order number and the size you need.'
    },
    {
      id: "cancel",
      keywords: ["cancel", "cancellation", "cancel my order", "change my order", "modify", "change address", "update order", "edit order"],
      response: 'Since all items are <strong>made to order</strong>, we <strong>cannot cancel or modify orders</strong> once they\u2019re placed. Production begins shortly after your order is confirmed.<br><br>If you have a special circumstance, email <a href="mailto:info@nosaddays.com" style="color:#000;font-weight:700">info@nosaddays.com</a> as soon as possible and we\u2019ll do our best to help.'
    },
    {
      id: "b2g1",
      keywords: ["buy 2 get 1", "b2g1", "bogo", "b1g1", "deal", "promotion", "promo", "discount", "free", "buy two", "2 get 1", "special", "offer", "coupon", "code", "promo code", "hoodie deal", "hoodie sale"],
      response: 'We have two deals running right now!<br><br>\u2022 <strong>Tees:</strong> Buy 2 Get 1 Free \u2014 mix and match any tees<br>\u2022 <strong>Hoodies:</strong> Buy 1 Get 1 50% Off \u2014 mix and match any hoodies<br><br>Both discounts are <strong>applied automatically</strong> at checkout \u2014 no code needed. Just add your items to cart.'
    },
    {
      id: "sizing",
      keywords: ["size", "sizing", "fit", "size chart", "what size", "measurements", "runs big", "runs small", "true to size", "tts", "size guide"],
      response: 'Our items generally run <strong>true to size</strong>. Each product page has a detailed size chart \u2014 just scroll down on any product to find measurements.<br><br>If you\u2019re between sizes, we recommend going <strong>one size up</strong> for a more relaxed fit.'
    },
    {
      id: "donation",
      keywords: ["donate", "donation", "charity", "give back", "cause", "10%", "ten percent", "mission", "purpose", "mental health", "no sad days meaning"],
      response: '<strong>10% of every sale</strong> is donated to mental health organizations. It\u2019s automatic \u2014 every purchase you make helps support the cause. No Sad Days is built on the belief that fashion can make a real difference. \ud83d\udc9b'
    },
    {
      id: "contact",
      keywords: ["contact", "email", "phone", "reach", "talk to someone", "human", "agent", "real person", "help", "support", "speak", "customer service", "representative"],
      response: 'You can reach our team at <a href="mailto:info@nosaddays.com" style="color:#000;font-weight:700">info@nosaddays.com</a>.<br><br>Please <strong>do not send support requests via social media DMs</strong> \u2014 email is the fastest way to get help. We typically respond within 24 hours.'
    },
    {
      id: "payment",
      keywords: ["payment", "pay", "credit card", "debit", "apple pay", "shop pay", "paypal", "afterpay", "klarna", "installment", "accepted"],
      response: 'We accept all major credit/debit cards, Apple Pay, Google Pay, and Shop Pay at checkout. All payments are processed securely through Shopify.'
    },
    {
      id: "international",
      keywords: ["international", "ship worldwide", "outside us", "canada", "uk", "europe", "overseas", "global", "worldwide", "other countries"],
      response: 'Currently we ship within the <strong>United States</strong>. International shipping may have additional fees and longer delivery times. For international orders, email <a href="mailto:info@nosaddays.com" style="color:#000;font-weight:700">info@nosaddays.com</a> and we\u2019ll let you know your options.'
    },
    {
      id: "mental_health",
      keywords: ["mental health", "resources", "wellness", "well-being", "wellbeing", "self care", "self-care", "therapy", "therapist", "counseling", "counselor", "mental health resources", "feel better", "getting help", "need help", "struggling"],
      response: 'No Sad Days exists because mental health matters. <strong>A portion of every order</strong> helps fund therapy access \u2014 and we want to make sure you have access to support too.<br><br><strong>Free resources available 24/7:</strong><br><br>\ud83d\udcde <strong><a href="tel:988" style="color:#000">988 Suicide & Crisis Lifeline</a></strong><br>Call or text <strong>988</strong> \u2014 free, confidential, 24/7<br><br>\ud83d\udcac <strong><a href="https://www.crisistextline.org/" target="_blank" rel="noopener" style="color:#000">Crisis Text Line</a></strong><br>Text <strong>HOME</strong> to <strong>741741</strong><br><br>\ud83c\udfe5 <strong><a href="https://www.samhsa.gov/find-help/helplines/national-helpline" target="_blank" rel="noopener" style="color:#000">SAMHSA Helpline</a></strong><br>Call <strong>1-800-662-4357</strong> for treatment referrals<br><br>\ud83d\udcbb <strong><a href="https://www.nami.org/" target="_blank" rel="noopener" style="color:#000">NAMI</a></strong> (National Alliance on Mental Illness)<br><a href="https://www.nami.org/help" target="_blank" rel="noopener" style="color:#000">nami.org/help</a> \u2014 support groups, education & advocacy<br><br>You\u2019re not alone, and reaching out is a sign of strength. \ud83d\udc9b'
    },
    {
      id: "crisis",
      keywords: ["suicide", "suicidal", "kill myself", "end it", "don't want to live", "want to die", "hurting myself", "self harm", "self-harm", "cutting", "overdose", "no reason to live", "hopeless", "can't go on", "give up", "not worth it", "end my life"],
      response: '<strong>We\u2019re glad you reached out.</strong> You matter, and you deserve support right now.<br><br>Please connect with someone who can help:<br><br>\ud83d\udcde <strong style="font-size:15px"><a href="tel:988" style="color:#000">Call or text 988</a></strong><br>Suicide & Crisis Lifeline \u2014 free, confidential, 24/7<br><br>\ud83d\udcac <strong>Text HOME to 741741</strong><br>Crisis Text Line \u2014 if you\u2019d rather text than talk<br><br>\ud83c\udfe5 <strong>Go to your nearest emergency room</strong><br>If you\u2019re in immediate danger<br><br>You are not alone. There are people who care and want to help you through this. Reaching out takes courage, and you\u2019ve already taken that step. \ud83d\udc9b',
      priority: true
    },
    {
      id: "anxiety",
      keywords: ["anxious", "anxiety", "panic", "panic attack", "stressed", "overwhelmed", "can't breathe", "can't sleep", "insomnia", "depressed", "depression", "sad", "lonely", "alone", "scared", "worried", "burnout", "burned out", "exhausted", "broken", "falling apart", "not okay", "not ok"],
      response: 'We hear you, and it\u2019s okay to not be okay. That\u2019s literally why No Sad Days exists \u2014 to remind people that brighter days are ahead.<br><br>Here are some things that might help right now:<br><br>\ud83d\udcde <strong><a href="tel:988" style="color:#000">988 Suicide & Crisis Lifeline</a></strong> \u2014 Call or text 988 (not just for crisis \u2014 they help with anxiety, depression & emotional distress too)<br><br>\ud83d\udcac <strong>Crisis Text Line</strong> \u2014 Text <strong>HOME</strong> to <strong>741741</strong> to chat with a trained counselor<br><br>\ud83c\udfe5 <strong><a href="https://www.samhsa.gov/find-help/helplines/national-helpline" target="_blank" rel="noopener" style="color:#000">SAMHSA Helpline</a></strong> \u2014 Call 1-800-662-4357 for free treatment referrals<br><br>\ud83e\uddd8 <strong><a href="https://www.nami.org/help" target="_blank" rel="noopener" style="color:#000">NAMI Support</a></strong> \u2014 nami.org/help for support groups & resources<br><br>Taking care of your mind is just as important as anything else. You deserve support. \ud83d\udc9b'
    }
  ];

  // ========== Quick Action Buttons ==========
  var QUICK_ACTIONS = [
    { label: "\ud83d\udce6 Track Order", faqId: "track_order" },
    { label: "\ud83d\ude9a Shipping Info", faqId: "shipping_time" },
    { label: "\ud83d\udd04 Returns", faqId: "returns" },
    { label: "\ud83c\udff7\ufe0f B2G1 Deal", faqId: "b2g1" },
    { label: "\ud83d\udccf Sizing", faqId: "sizing" },
    { label: "\ud83d\udc9b Need Support?", faqId: "mental_health" }
  ];

  // ========== DOM References ==========
  var els = {};

  // ========== State ==========
  var isOpen = false;
  var conversationStarted = false;

  // ========== Init ==========
  function init() {
    els.toggle = document.getElementById("nsd-chat-toggle");
    els.window = document.getElementById("nsd-chat-window");
    els.messages = document.getElementById("nsd-chat-messages");
    els.actions = document.getElementById("nsd-chat-actions");
    els.input = document.getElementById("nsd-chat-input");
    els.sendBtn = document.getElementById("nsd-chat-send");
    els.minimize = document.getElementById("nsd-chat-minimize");
    els.chatIcon = els.toggle.querySelector(".nsd-chat__toggle-icon--chat");
    els.closeIcon = els.toggle.querySelector(".nsd-chat__toggle-icon--close");
    els.badge = els.toggle.querySelector(".nsd-chat__badge");

    if (!els.toggle || !els.window) return;

    // Event listeners
    els.toggle.addEventListener("click", toggleChat);
    els.minimize.addEventListener("click", toggleChat);
    els.sendBtn.addEventListener("click", handleSend);
    els.input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        handleSend();
      }
    });

    // Show badge after 4 seconds if chat hasn't been opened this session
    setTimeout(function () {
      if (!isOpen && !sessionStorage.getItem("nsd_chat_opened")) {
        els.badge.style.display = "flex";
      }
    }, 4000);

    renderQuickActions();
  }

  // ========== Toggle Chat ==========
  function toggleChat() {
    isOpen = !isOpen;

    if (isOpen) {
      els.window.style.display = "flex";
      els.chatIcon.style.display = "none";
      els.closeIcon.style.display = "block";
      els.badge.style.display = "none";
      els.toggle.setAttribute("aria-expanded", "true");
      sessionStorage.setItem("nsd_chat_opened", "1");

      if (!conversationStarted) {
        conversationStarted = true;
        addBotMessage("Hey there! \ud83d\udc4b I\u2019m the No Sad Days support bot. I can help with order tracking, shipping, returns, sizing, and more. I\u2019m also here if you need mental health resources \u2014 because that\u2019s what we\u2019re all about. \ud83d\udc9b");
      }

      setTimeout(function () {
        els.input.focus();
      }, 300);
    } else {
      els.window.style.display = "none";
      els.chatIcon.style.display = "block";
      els.closeIcon.style.display = "none";
      els.toggle.setAttribute("aria-expanded", "false");
    }
  }

  // ========== Render Quick Actions ==========
  function renderQuickActions() {
    els.actions.innerHTML = "";
    QUICK_ACTIONS.forEach(function (action) {
      var btn = document.createElement("button");
      btn.className = "nsd-chat__action-btn";
      btn.textContent = action.label;
      btn.addEventListener("click", function () {
        handleQuickAction(action);
      });
      els.actions.appendChild(btn);
    });
  }

  function handleQuickAction(action) {
    addUserMessage(action.label);
    var faq = findFaqById(action.faqId);
    if (faq) {
      showTypingThenRespond(faq);
    }
  }

  function findFaqById(id) {
    for (var i = 0; i < FAQ_DATA.length; i++) {
      if (FAQ_DATA[i].id === id) return FAQ_DATA[i];
    }
    return null;
  }

  // ========== Send Message ==========
  function handleSend() {
    var text = els.input.value.trim();
    if (!text) return;

    els.input.value = "";
    addUserMessage(text);
    processUserMessage(text);
  }

  // ========== Process Message ==========
  function processUserMessage(text) {
    var lower = text.toLowerCase().replace(/[^a-z0-9\s]/g, " ").replace(/\s+/g, " ").trim();

    // PRIORITY CHECK: Crisis keywords always win. These are life-critical
    var crisisFaq = findFaqById("crisis");
    if (crisisFaq) {
      for (var c = 0; c < crisisFaq.keywords.length; c++) {
        if (lower.indexOf(crisisFaq.keywords[c].toLowerCase()) !== -1) {
          showTypingThenRespond(crisisFaq);
          return;
        }
      }
    }

    // SECONDARY PRIORITY: Anxiety/distress keywords
    var anxietyFaq = findFaqById("anxiety");
    if (anxietyFaq) {
      for (var a = 0; a < anxietyFaq.keywords.length; a++) {
        if (lower.indexOf(anxietyFaq.keywords[a].toLowerCase()) !== -1) {
          showTypingThenRespond(anxietyFaq);
          return;
        }
      }
    }

    var bestMatch = null;
    var bestScore = 0;

    for (var i = 0; i < FAQ_DATA.length; i++) {
      var faq = FAQ_DATA[i];
      // Skip crisis and anxiety, already checked above
      if (faq.id === "crisis" || faq.id === "anxiety") continue;

      var score = 0;
      var matchedKeywords = [];

      for (var k = 0; k < faq.keywords.length; k++) {
        var kw = faq.keywords[k].toLowerCase();
        if (lower.indexOf(kw) !== -1) {
          // Longer keyword phrases get much more weight (specificity)
          var wordCount = kw.split(" ").length;
          score += wordCount * 3;
          matchedKeywords.push(kw);
        }
      }

      // Exact question patterns boost, these override generic matches
      if (lower.indexOf("where") !== -1 && lower.indexOf("order") !== -1 && lower.indexOf("return") === -1 && lower.indexOf("cancel") === -1) {
        if (faq.id === "track_order") score += 10;
      }
      if (lower.indexOf("can i cancel") !== -1 || lower.indexOf("cancel my") !== -1) {
        if (faq.id === "cancel") score += 10;
      }
      if (lower.indexOf("return") !== -1 || lower.indexOf("exchange") !== -1 || lower.indexOf("refund") !== -1) {
        if (faq.id === "returns") score += 10;
      }
      if (lower.indexOf("cancel") !== -1) {
        if (faq.id === "cancel") score += 10;
      }
      if ((lower.indexOf("buy 1") !== -1 || lower.indexOf("buy 2") !== -1 || lower.indexOf("buy two") !== -1 || lower.indexOf("b1g1") !== -1 || lower.indexOf("b2g1") !== -1 || lower.indexOf("bogo") !== -1 || lower.indexOf("hoodie deal") !== -1 || lower.indexOf("hoodie sale") !== -1)) {
        if (faq.id === "b2g1") score += 10;
      }
      if (lower.indexOf("mental health") !== -1 || lower.indexOf("resources") !== -1 || lower.indexOf("therapy") !== -1 || lower.indexOf("counseling") !== -1) {
        if (faq.id === "mental_health") score += 10;
      }

      // Penalize generic "my order" match for track_order when more specific intent is present
      if (faq.id === "track_order" && matchedKeywords.length === 1 && matchedKeywords[0] === "my order") {
        // Only matched "my order", very generic, reduce score
        score = Math.max(0, score - 4);
      }

      if (score > bestScore) {
        bestScore = score;
        bestMatch = faq;
      }
    }

    if (bestMatch && bestScore >= 2) {
      showTypingThenRespond(bestMatch);
    } else if (bestScore >= 1) {
      // Partial match, respond but also offer more help
      showTypingThenRespond(bestMatch);
    } else {
      // No match
      showTypingThenMessage(
        'I\u2019m not sure I have the answer to that, but I\u2019d love to help! Here are some topics I can assist with, or you can email our team at <a href="mailto:info@nosaddays.com" style="color:#000;font-weight:700">info@nosaddays.com</a> for personalized help.',
        function () {
          els.actions.style.display = "flex";
          renderQuickActions();
        }
      );
    }
  }

  // ========== Typing Indicator ==========
  function showTyping() {
    var typing = document.createElement("div");
    typing.className = "nsd-chat__typing";
    typing.id = "nsd-typing";
    typing.innerHTML =
      '<div class="nsd-chat__typing-dot"></div>' +
      '<div class="nsd-chat__typing-dot"></div>' +
      '<div class="nsd-chat__typing-dot"></div>';
    els.messages.appendChild(typing);
    scrollToBottom();
    return typing;
  }

  function removeTyping() {
    var el = document.getElementById("nsd-typing");
    if (el) el.remove();
  }

  function showTypingThenMessage(html, callback) {
    showTyping();
    var delay = 500 + Math.floor(Math.random() * 500);
    setTimeout(function () {
      removeTyping();
      addBotMessage(html);
      if (callback) callback();
    }, delay);
  }

  function showTypingThenRespond(faq) {
    showTyping();
    var delay = 500 + Math.floor(Math.random() * 500);
    setTimeout(function () {
      removeTyping();
      addBotMessage(faq.response);

      // Handle follow-up suggestions
      if (faq.followUp) {
        setTimeout(function () {
          var followFaq = findFaqById(faq.followUp);
          if (followFaq) {
            var wrapper = document.createElement("div");
            wrapper.style.cssText = "padding:0 0 4px;display:flex";
            var btn = document.createElement("button");
            btn.className = "nsd-chat__action-btn";
            btn.textContent = "\ud83d\udce6 Yes, track my order";
            btn.addEventListener("click", function () {
              wrapper.remove();
              addUserMessage("Track my order");
              showTypingThenRespond(followFaq);
            });
            wrapper.appendChild(btn);
            els.messages.appendChild(wrapper);
            scrollToBottom();
          }
        }, 300);
      }

      // After any response, show "Anything else?" after a pause
      setTimeout(function () {
        showAnythingElse();
      }, 1500);
    }, delay);
  }

  function showAnythingElse() {
    var wrapper = document.createElement("div");
    wrapper.style.cssText = "display:flex;flex-wrap:wrap;gap:6px;padding:4px 0";

    var btnMore = document.createElement("button");
    btnMore.className = "nsd-chat__action-btn";
    btnMore.textContent = "Ask something else";
    btnMore.addEventListener("click", function () {
      wrapper.remove();
      els.actions.style.display = "flex";
      renderQuickActions();
      scrollToBottom();
    });
    wrapper.appendChild(btnMore);

    var btnDone = document.createElement("button");
    btnDone.className = "nsd-chat__action-btn";
    btnDone.textContent = "That\u2019s all, thanks!";
    btnDone.addEventListener("click", function () {
      wrapper.remove();
      addBotMessage("You\u2019re welcome! If you need anything else, I\u2019m always right here. Have a great day! \ud83d\udc9b");
    });
    wrapper.appendChild(btnDone);

    els.messages.appendChild(wrapper);
    scrollToBottom();
  }

  // ========== Message Helpers ==========
  function addBotMessage(html) {
    var msg = document.createElement("div");
    msg.className = "nsd-chat__msg nsd-chat__msg--bot";
    msg.innerHTML = html;
    els.messages.appendChild(msg);
    scrollToBottom();
  }

  function addUserMessage(text) {
    var msg = document.createElement("div");
    msg.className = "nsd-chat__msg nsd-chat__msg--user";
    msg.textContent = text;
    els.messages.appendChild(msg);
    scrollToBottom();

    // Hide quick actions after first user message
    if (els.actions) els.actions.style.display = "none";
  }

  function scrollToBottom() {
    requestAnimationFrame(function () {
      els.messages.scrollTop = els.messages.scrollHeight;
    });
  }

  // ========== Start ==========
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
